// Test only

<template>
  <!-- <div
    id="login-page"
    style="height: 100vh; text-align: center; color: white"
    :class="[
      { 'inset-box-shadow': !isMobileOrStandaloneMode },
      onsiteMode ? 'bg-blue-radial' : 'bg-teal-radial',
    ]"
  > -->
  <div
    id="login-page"
    style="height: 100vh; text-align: center; color: white"
    :class="[
      { 'inset-box-shadow': !isMobileOrStandaloneMode },
      onsiteMode ? 'bg-blue-dark' : 'bg-blue-dark',
    ]"
  >
    <v-toolbar dark color="transparent" elevation="0">
      <v-btn icon @click="goBack">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <div>
      <v-img
        style="margin: 50px 80px"
        src="@/assets/images/mylibrary-logo.png"
      ></v-img>

      <div class="ma-6">
        <v-text-field
          elevation="21"
          dark
          hide-details
          background-color="primary"
          class="mb-2"
          single-line
          solo
          clearable
          prepend-inner-icon="mdi-account"
        >
          <template slot="label"> <i>my</i>Library ID </template>
        </v-text-field>

        <v-text-field
          dark
          hide-details
          background-color="primary"
          class="mb-2"
          label="Password"
          single-line
          solo
          clearable
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
          :type="showPassword ? 'text' : 'password'"
          prepend-inner-icon="mdi-lock"
        ></v-text-field>

        <v-btn
          @click="login"
          id="btnLogin"
          onfocus="this.blur()"
          color="orange darken-2"
          large
          fabx
          block
          dark
          class="mt-6"
        >
          <v-icon></v-icon>Login
        </v-btn>

        <div class="pt-9">
          <a href="#" style="font-size: 0.875rem" class="white--text"
            >Don't have an account yet? Sign up!</a
          >
        </div>

        <div class="pt-0">
          <a href="#" style="font-size: 0.875rem" class="white--text"
            >Forgot everything?</a
          >
        </div>

        <div class="pt-0">
          <a href="#" style="font-size: 0.875rem" class="white--text"
            >Need help?</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "Login",
  data: () => ({
    showPassword: false,
  }),
  computed: {
    ...mapState(["showLoginPage"]),
    ...mapGetters(["authenticated"]),
  },
  methods: {
    ...mapMutations(["updateAccountInfo", "updateShowLoginPage"]),
    iconClicked() {
      if (!this.authenticated) {
        this.updateShowLoginPage(true);
      }
    },
    login() {
      // this.updateAccountInfo(null);

      // setTimeout(() => {
      //   const returnUrl = this.$route.query.redirectFrom;

      //   if (returnUrl) {
      //     this.$router.push(returnUrl);
      //   } else {
      //     this.goHome();
      //   }
      // }, 500);

      this.$nextTick(() => {
        const returnUrl = this.$route.query.redirectFrom;

        if (returnUrl) {
          this.$router.push(returnUrl);
        } else {
          this.goHome();
        }
      });
    },
  },
};
</script>

<style>
#login-page .v-input__prepend-inner .v-icon {
  color: white !important;
}
</style>